import {
    Component,
    OnInit,
    ViewChild,
    EventEmitter,
    AfterViewInit,
    ViewContainerRef,
    ComponentRef,
    Compiler,
    Injector,
    NgModuleRef,
    NgModule,
    Pipe,
    PipeTransform
} from "@angular/core";
import { CclMessageService, CclNotifyService, CclSharedModule } from "certain-common-library";
import { SharedService } from "../../../../modules/shared/services/shared.service";
import { AttendeeSessionService } from "../../../../modules/shared/services/attendee-session.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { RouterModule,ActivatedRoute } from "@angular/router";
import { SharedModule } from "../../../shared-module/shared-module";
import { CommonModule, DatePipe } from "@angular/common";
import * as mustache from "mustache";
import { cloneDeep } from "lodash";
import * as moment from 'moment';
 import 'moment-timezone';
import { Subscription } from "rxjs";

@Component({
    selector: "cart-section",
    templateUrl: "./cart-section.view.html",
    providers: []
})
export class CartSectionView implements OnInit {
    selectedTab = "registered";
    mysessionConfig: any;
    private mustache = mustache;
    output = "";
    registeredList: any;
    param: any = {};
    section = "";
    render: boolean = false;
    generalDataConfig: any;
    generalSessionConfig: any;
    buttonConfig: any;
    isLoading: boolean = false;
    favDatacopy: any;
    cartDatacopy: any;
    defaultCurrencySymbol: string;
    private subscription: Subscription;
    timezone;
    filterConfig;
    constructor(
        public sharedService: SharedService,
        private messageService: CclMessageService,
        private attendeeSessionService: AttendeeSessionService,
        private _flashMessagesService: FlashMessagesService,
        private notifyService: CclNotifyService,
        private compiler: Compiler,
        private injector: Injector,
        private moduleRef: NgModuleRef<any>,
        private datePipe: DatePipe,
        private route: ActivatedRoute
    ) {

        this.mysessionConfig = JSON.parse(this.sharedService.configs[this.sharedService.configTypes.MYSESSION].config);
        this.generalDataConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.DATA.general].config
        );

        this.filterConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.FILTER_CONFIG].config
        );
        if(!('selectTimezone' in this.filterConfig)) {
            this.filterConfig.selectTimezone = 'browser_timezone';
        }

        if (this.sharedService.event.eventDelivery === 'In Person' && this.filterConfig.isDefaultTimezone == true) {
            this.filterConfig.selectTimezone = 'event_timezone';
        }
        this.defaultCurrencySymbol = this.sharedService.event.currencySymbol || this.sharedService.currencySymbol;

        this.subscription = this.messageService.getMessage().subscribe((message) => this.listenMessage(message));

        this.param["template"] = this.mysessionConfig.catalogConfig.header.textConfig.template;
        this.param["template"] = this.param["template"].replace(
            "{@ddf.startTime@}",
            "{{'{@ddf.startTime@}'|toDateObj| date: '" +
                this.generalDataConfig.dateTimeFormats.dateFormat +
                "," +
                this.generalDataConfig.dateTimeFormats.timeFormat +
                "'}}"
        );

        this.param["template"] = this.param["template"].replace(
            "{@ddf.event.strStartDate@}",
            "{{'{@ddf.event.strStartDate@}'|toDateObj| date: '" +
                this.generalDataConfig.dateTimeFormats.dateFormat +
                "," +
                this.generalDataConfig.dateTimeFormats.timeFormat +
                "'}}"
        );
        this.param["template"] = this.param["template"].replace(
            "{@ddf.event.strEndDate@}",
            "{{'{@ddf.event.strEndDate@}'|toDateObj| date: '" +
                this.generalDataConfig.dateTimeFormats.dateFormat +
                "," +
                this.generalDataConfig.dateTimeFormats.timeFormat +
                "'}}"
        );

        this.param["template"] = this.param["template"].replace(
            "{@ddf.startDate@}",
            "{{'{@ddf.startTime@}'|toDateObj| date: '" + this.generalDataConfig.dateTimeFormats.dateFormat + "'}}"
        );

        this.param["template"] = this.param["template"].replace(
            "{@ddf.startTimeHHmm@}",
            "{{'{@ddf.startTime@}'|toDateObj| date: '" + this.generalDataConfig.dateTimeFormats.timeFormat + "'}}"
        );

        this.param["template"] = this.param["template"].replace(
            "{@ddf.startDateTime@}",
            "{{'{@ddf.startTime@}'|toDateObj| date: '" +
                this.generalDataConfig.dateTimeFormats.dateFormat +
                "," +
                this.generalDataConfig.dateTimeFormats.timeFormat +
                "'}}"
        );

        this.param["template"] = this.param["template"].replace(
            "{@ddf.endTime@}",
            "{{'{@ddf.endTime@}'|toDateObj| date: '" + this.generalDataConfig.dateTimeFormats.timeFormat + "'}}"
        );

        this.param["template"] = this.param["template"].replace(
            "{@ddf.endDateTime@}",
            "{{'{@ddf.endTime@}'|toDateObj| date: '" +
                this.generalDataConfig.dateTimeFormats.dateFormat +
                "," +
                this.generalDataConfig.dateTimeFormats.timeFormat +
                "'}}"
        );

        this.param["template"] = this.param["template"].replace(
            "{@ddf.endDate@}",
            "{{'{@ddf.endTime@}'|toDateObj| date: '" + this.generalDataConfig.dateTimeFormats.dateFormat + "'}}"
        );

        this.param["template"] = this.param["template"].replace(
            "{@ddf.endTimeHHmm@}",
            "{{'{@ddf.endTime@}'|toDateObj| date: '" + this.generalDataConfig.dateTimeFormats.timeFormat + "'}}"
        );

        this.param["template"] = this.getSafeHtmlStr(this.param["template"]);

        this.param["template"] = this.param["template"].replace(
            new RegExp("{@ddf.tags@}", "g"),
            '<span class="tagsContainer">{@ddf.#tags@}<span>{@ddf.name@}</span>{@ddf./tags@}</span>'
        );
        //for speaker list
        this.param["template"] = this.param["template"].replace(
            new RegExp("{@ddf.speakerList@}", "g"),
            '<span class="speakerContainer">{@ddf.#speakers@}<span class="speakerItem">{@ddf.speakerFirstName@} {@ddf.speakerLastName@}</span>{@ddf./speakers@}</span>'
        );

        //for Session Fee or Session cancellation Fee
        this.param["template"] = this.param["template"].replace("{@ddf.currentFee@}", this.defaultCurrencySymbol + ' {@ddf.currentFee@}');

        this.param["template"] = this.param["template"].replace("{@ddf.currentCancellationFee@}", this.defaultCurrencySymbol + ' {@ddf.currentCancellationFee@}');

        // Replace Session Industries and JobFunctions DDF values
        this.param["template"] = this.param["template"].replace(
            new RegExp("{@ddf.confIndustrys@}", "g"),
            '<span class="industrysContainer">{@ddf.#confIndustrys@}<span>{@ddf.name@}</span>{@ddf./confIndustrys@}</span>'
        );

        this.param["template"] = this.param["template"].replace(
            new RegExp("{@ddf.confJobFunctions@}", "g"),
            '<span class="jobFunctionsContainer">{@ddf.#confJobFunctions@}<span>{@ddf.name@}</span>{@ddf./confJobFunctions@}</span>'
        );

        this.param["style"] = this.createStyleString(this.mysessionConfig.catalogConfig.header);
        this.param["attendeeSessionService"] = this.attendeeSessionService;
        this.param["sharedService"] = this.sharedService;
        this.param["messageService"] = this.messageService;

        this.generalSessionConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.SESSION.general].config
        );

        if(!('instanceCheckValidation' in this.generalSessionConfig.catalogConfig)) {
            this.generalSessionConfig.catalogConfig['instanceCheckValidation'] = false;
        }

        if(!('inventoryLock' in this.generalSessionConfig.catalogConfig)) {
            this.generalSessionConfig.catalogConfig['inventoryLock'] = false;
        }
        this.buttonConfig = this.generalSessionConfig["catalogConfig"]["buttonConfig"];

        if (!this.buttonConfig.hasOwnProperty("enableAddToCartButton")) {
            this.buttonConfig["enableAddToCartButton"] = true;
        }

        if (this.buttonConfig.enableAddToCartButton) {
            this.sharedService.renderCartViewSubject.subscribe((value) => {
                if (value) {
                    this.render = false;
                    this.selectedTab = "registered";
                    var customTags = ["{@ddf.", "@}"];
                    this.mustache.tags = customTags;
                    this.section = "";
                    this.sharedService.showLoader = false;
                    if (this.listViewContainer) {
                        this.listViewContainer.clear();
                    }
                    this.isLoading = true;
                    this.attendeeSessionService
                        .getCartData(this.sharedService.loggedInAttendee.uuid)
                        .subscribe((resp) => {
                            this.sharedService.cartData = resp.body;
                            if(this.sharedService.cartData && this.sharedService.cartData.sessions) {
                                this.sharedService.cartData.sessions.forEach(element => {
                                    if(element.capacity > 0 && (element.remaining == null) && element.registered == null) {
                                        element.remaining = element.capacity;
                                    }
                
                                    if(element.waitlistedLimit && element.waitlistedLimit > 0 && (element.waitlisted == null || element.waitlisted == 0)) {
                                        element.remainingWaitlist = element.waitlistedLimit;
                                    }
                                });
                            }
                            this.cartDatacopy = cloneDeep(this.sharedService.cartData["sessions"]);
                            this.sharedService.showLoader = true;
                            this.isLoading = false;
                            this.render = true;
                            this.sharedService.updateDateTime(this.sharedService.cartData["sessions"], this.filterConfig.selectTimezone);
                        });
                }
            });
        } else {
            this.sharedService.renderCartViewSubject.subscribe((value) => {
                if (value) {
                    this.render = false;
                    this.selectedTab = "favorites";
                    var customTags = ["{@ddf.", "@}"];
                    this.mustache.tags = customTags;
                    this.section = "";
                    if (this.listViewContainer) {
                        this.listViewContainer.clear();
                    }
                    this.isLoading = true;
                    this.sharedService.showLoader = false;
                    this.attendeeSessionService
                        .getFavoritesData(this.sharedService.loggedInAttendee.uuid)
                        .subscribe((resp) => {
                            this.isLoading = false;
                            this.sharedService.showLoader = true;
                            this.sharedService.favData = cloneDeep(resp.body);
                            this.sharedService.favData.sessions = [];
                            resp.body["sessions"].forEach((element) => {
                                if(element.capacity > 0 && (element.remaining == null) && element.registered == null) {
                                    element.remaining = element.capacity;
                                }
            
                                if(element.waitlistedLimit && element.waitlistedLimit > 0 && (element.waitlisted == null || element.waitlisted == 0)) {
                                    element.remainingWaitlist = element.waitlistedLimit;
                                }
                                if (!element.isExcluded) {
                                    this.sharedService.favData.sessions.push(element);
                                }
                            });
                            this.favDatacopy = cloneDeep(this.sharedService.favData.sessions);
                            this.sharedService.updateDateTime(this.sharedService.favData.sessions, this.filterConfig.selectTimezone);
                            this.sharedService.favData.size = this.sharedService.favData.sessions.length;
                            this.render = true;
                        });
                }
            });
        }
    }

    listenMessage(message) {
        if (message.text == "apply-my-timezone") {
            this.filterConfig.selectTimezone = 'browser_timezone';
            if(this.sharedService.cartData["sessions"] && this.sharedService.cartData["sessions"]?.length>0) {
                this.sharedService.updateDateTime(this.sharedService.cartData["sessions"], this.filterConfig.selectTimezone);
            }
            if(this.sharedService.favData?.sessions && this.sharedService.favData?.sessions?.length>0) {
                this.sharedService.updateDateTime(this.sharedService.favData["sessions"], this.filterConfig.selectTimezone);
            }
        }

        if(message.text == "apply-session-timezone") {
            this.sharedService.favData.sessions = this.favDatacopy;
            this.sharedService.cartData["sessions"] = this.cartDatacopy;
        }
    }

    getSafeHtmlStr(template) {
        template = template.replace(new RegExp("{@ddf.abstractDesc@}", "g"), "<div>{@ddf.&abstractDesc@}</div>");
        template = template.replace(new RegExp("{@ddf.biography@}", "g"), "<div>{@ddf.&biography@}</div>");
        return template.replace(
            new RegExp("{@ddf.sessionDescription@}", "g"),
            "<div>{@ddf.&sessionDescription@}</div>"
        );
    }

    ngOnInit() {
        this.mysessionConfig = JSON.parse(this.sharedService.configs[this.sharedService.configTypes.MYSESSION].config);
    }

    createTemplate(sessionList) {
        var list = {};
        var idx = 0;
        var output = "";
        list = {
            sessions: sessionList,
            idx: function() {
                idx++;
                return;
            },
            index: function() {
                return idx;
            }
        };

        output = this.mustache.render(
            "{@ddf.#sessions@}<div *ngIf='show[{@ddf.index@}]' [ngClass]=\"'my-session-catalog-header'\" " +
                ">" +
                this.param["template"] +
                "<div class='cart-fa-icon-container'><i *ngIf=\"'favorites' === '" +
                this.selectedTab +
                "' && " +
                this.buttonConfig.enableAddToCartButton +
                " \" title='Add to Cart' (cclClick)='processFav({@ddf.index@},{@ddf.id@})' " +
                'class="fa fa-cart-arrow-down cart-arrow-down-icon cursor-pointer" ' +
                "></i><i title='Remove' (cclClick)='removeElement({@ddf.index@},{@ddf.id@},\"" +
                this.selectedTab +
                '")\' class="fa fa-times times-icon cursor-pointer"></i></div></div>{@ddf.idx@}{@ddf./sessions@}',
            list
        );
        return output;
    }

    toggleTab(tab) {
        this.sharedService.showLoader = false;
        this.isLoading = true;
        this.render = false;
        if (tab === "registered") {
            this.selectedTab = tab;
            this.attendeeSessionService.getCartData(this.sharedService.loggedInAttendee.uuid).subscribe((resp) => {
                this.isLoading = false;
                this.sharedService.showLoader = true;
                this.sharedService.cartData = resp.body;
                if(this.sharedService.cartData && this.sharedService.cartData.sessions) {
                    this.sharedService.cartData.sessions.forEach(element => {
                        if(element.capacity > 0 && (element.remaining == null) && element.registered == null) {
                            element.remaining = element.capacity;
                        }
    
                        if(element.waitlistedLimit && element.waitlistedLimit > 0 && (element.waitlisted == null || element.waitlisted == 0)) {
                            element.remainingWaitlist = element.waitlistedLimit;
                        }
                    });
                }
                this.cartDatacopy = cloneDeep(this.sharedService.cartData["sessions"]);
                this.sharedService.updateDateTime(this.sharedService.cartData["sessions"], this.filterConfig.selectTimezone);
                this.render = true;
            });
        } else if (tab === "favorites" || tab === "excluded") {
            this.selectedTab = tab;
            this.attendeeSessionService.getFavoritesData(this.sharedService.loggedInAttendee.uuid).subscribe((resp) => {
                this.isLoading = false;
                this.sharedService.showLoader = true;
                if (tab === "favorites") {
                    this.sharedService.favData = cloneDeep(resp.body);
                    this.sharedService.favData.sessions = [];
                    resp.body["sessions"].forEach((element) => {
                        if(element.capacity > 0 && (element.remaining == null) && element.registered == null) {
                            element.remaining = element.capacity;
                        }
    
                        if(element.waitlistedLimit && element.waitlistedLimit > 0 && (element.waitlisted == null || element.waitlisted == 0)) {
                            element.remainingWaitlist = element.waitlistedLimit;
                        }
                        if (!element.isExcluded) {
                            this.sharedService.favData.sessions.push(element);
                        }
                    });
                    this.favDatacopy = cloneDeep(this.sharedService.favData.sessions);
                    this.sharedService.updateDateTime(this.sharedService.favData.sessions, this.filterConfig.selectTimezone);
                    this.sharedService.favData.size = this.sharedService.favData.sessions.length;
                    this.render = true;
                } else {
                    this.sharedService.excData = cloneDeep(resp.body);
                    this.sharedService.excData.sessions = [];
                    resp.body["sessions"].forEach((element) => {
                        if (element.isExcluded) {
                            this.sharedService.excData.sessions.push(element);
                        }
                    });
                    this.sharedService.excData.size = this.sharedService.excData.sessions.length;
                    this.selectedTab = tab;
                }
            });
        }
    }

    processCart() {
        if (this.sharedService.cartData.sessions.length > 0) {
            this.attendeeSessionService.processCart(this.sharedService.loggedInAttendee.uuid, this.generalSessionConfig?.catalogConfig?.instanceCheckValidation).subscribe((response) => {
                this.messageService.sendMessage("process-cart", response.body);
                this.confirmRemoveFilter(response.body);
            },
            (err) => {
                this["_flashMessagesService"].show(err.error.errorResponse.errors[0], {
                    cssClass: "alert-danger"
                });
            });
        } else {
            this.messageService.sendMessage("toggle-cart");
        }
    }

    confirmRemoveFilter(paletteItem: any) {
        var title = "Cart Processed Successfully!";
        var buttonText = "OK";
        var hideCancel = "hide-cancel-button";
        if (
            this.mysessionConfig.formId != null &&
            this.mysessionConfig.formDTO != null &&
            this.mysessionConfig.formDTO.pkFormId != null
        ) {
            buttonText = "Continue to verify page";
            hideCancel = "";
        }
        var m = "";
        if (paletteItem["registered"].length > 0) {
            var htmlLi = "";
            this.sharedService.cartData.sessions.forEach((element) => {
                element.locationName = element.locationName ? element.locationName : '';
                paletteItem["registered"].forEach((ele) => {
                    if (element.id == ele) {
                        htmlLi +=
                            "<li class='text-justify'><i title=\"Calendar\" class='fa fa-calendar panel-reg-list-icon'></i><span class='font-weight-bold'>" +
                            element.sessionTitle +
                            "</span><br><span class='panel-subtext'>" +
                            element.locationName +
                            this.datePipe.transform(element.startTime, element.locationName ? " - EEEE, MMM dd | h:mm aa" : "EEEE, MMM dd | h:mm aa") +
                            "</span>" +
                            "</li>";
                    }
                });
            });
            m +=
                "<button class='accordion-custom btn-outine'><i title=\"Successfully Added\"  class='fa fa-calendar-check-o panel-reg-icon'></i>" +
                paletteItem["registered"].length +
                " Sessions Successfully Added to Your Schedule <span class='fa fa-angle-double-down panel-down-arrow-icon pull-right'></span><br><span class='panel-heading-subtext'>Expand for more detail.</span><hr class='panel-hr'></button><div class='accordion-custom-panel accordion-custom-success'><p><ul class='panel-content'>" +
                htmlLi +
                "</ul></p></div>";
        }
        if (paletteItem["waitlisted"].length > 0) {
            title = "Cart Processed With Issues...";
            var htmlLi = "";
            this.sharedService.cartData.sessions.forEach((element) => {
                element.locationName = element.locationName ? element.locationName : '';
                paletteItem["waitlisted"].forEach((ele) => {
                    if (element.id == ele) {
                        htmlLi +=
                            "<li class='text-justify'><i title=\"Waitlisted\" class='fa fa-hourglass-start panel-wait-icon'></i><span class='font-weight-bold'>" +
                            element.sessionTitle +
                            "</span><br><span class='panel-subtext'>" +
                            element.locationName +
                            this.datePipe.transform(element.startTime, element.locationName ? " - EEEE, MMM dd | h:mm aa" : "EEEE, MMM dd | h:mm aa") +
                            "</span>" +
                            "</li>";
                    }
                });
            });
            m +=
                "<button class='accordion-custom btn-outine'> <i title=\"Waitlisted\" class='fa fa-hourglass-start panel-wait-icon'></i>" +
                paletteItem["waitlisted"].length +
                " Sessions Waitlisted <span class='fa fa-angle-double-down panel-down-arrow-icon pull-right'></span><br><span class='panel-heading-subtext'>Expand for more detail.</span><hr class='panel-hr'></button><div class='accordion-custom-panel accordion-custom-info'><p><ul class='panel-content'>" +
                htmlLi +
                "</ul></p></div>";
        }
        if (paletteItem["failed"].length > 0) {
            title = "Cart Processed With Issues...";
            var htmlLi = "";
            this.sharedService.cartData.sessions.forEach((element) => {
                element.locationName = element.locationName ? element.locationName : '';
                paletteItem["failed"].forEach((ele) => {
                    if (element.id == ele) {
                        htmlLi +=
                            "<li class='text-justify'><i title=\"Unavailable\" class='fa fa-calendar-times-o panel-full-icon'></i><span class='font-weight-bold'>" +
                            element.sessionTitle +
                            "</span><br><span class='panel-subtext'>" +
                            element.locationName +
                            this.datePipe.transform(element.startTime, element.locationName ? " - EEEE, MMM dd | h:mm aa" : "EEEE, MMM dd | h:mm aa") +
                            "</span>" +
                            "</li>";
                    }
                });
            });
            m +=
                "<button class='accordion-custom btn-outine'><i title=\"Unavailable\" class='fa fa-calendar-times-o panel-full-icon'></i>" +
                paletteItem["failed"].length +
                " Sessions No Longer Available <span class='fa fa-angle-double-down panel-down-arrow-icon pull-right'></span><br><span class='panel-heading-subtext'>Expand for more detail.</span><hr class='panel-hr'></button><div class='accordion-custom-panel accordion-custom-danger'><p><ul class='panel-content'>" +
                htmlLi +
                "</ul></p></div>";
        }
        this.messageService.sendMessage("toggle-cart");
        let buttonArray = []
        let cancelButton = {
            text: "Cancel",
            textTrusted: false,
            addClass: "cart-popup-cancel",
            primary: true,
            promptTrigger: true,
            click: (notice, value) => {
                notice.close();
                notice.fire("pnotify.cancel", { notice, value });
            }
        }
        let okButton = {
            text: buttonText,
            textTrusted: false,
            addClass: "",
            primary: true,
            promptTrigger: true,
            click: (notice, value) => {
                if (buttonText != "OK") {
                    window.open(
                        "/profile/form/index.cfm?PKformID=" +
                            this.mysessionConfig.formDTO.pkFormId +
                            "&varPage=verify&pkProfileId=" +
                            this.sharedService.loggedInAttendee.profile.pkProfileId,
                        "_blank"
                    );
                }
                notice.close();
                notice.fire("pnotify.confirm", { notice, value });
            }
        }
        if (paletteItem["registered"].length > 0) {
            buttonArray = [okButton]
        } else {
            buttonArray = [cancelButton,okButton]
        }

        const pnotify = this.notifyService.getPNotify();
        pnotify.alert({
            title: title,
            text: m,
            addClass: "c-pnotify-confirm cart-alert cart-processed",
            hide: false,
            textTrusted: true,
            modules: {
                Confirm: {
                    confirm: true,
                    align: "flex-end",
                    buttons: buttonArray
                },
                Buttons: {
                    closer: true,
                    sticker: false
                }
            },
            stack: {
                modal: true
            }
        });

        var acc = document.getElementsByClassName("accordion-custom");
        var i;

        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function() {
                this.classList.toggle("active");
                this.getElementsByClassName("fa-angle-double-down")[0].classList.toggle("fa-rotate-180");
                var panel = this.nextElementSibling;
                if (panel.style.display === "block") {
                    panel.style.display = "none";
                } else {
                    panel.style.display = "block";
                }
            });
        }
    }

    addAllToCart() {
        this.sharedService.showLoader = false;
        this.isLoading = true;
        this.attendeeSessionService.processAllFav(this.sharedService.loggedInAttendee.uuid).subscribe((response) => {
            this.sharedService.showLoader = true;
            this.isLoading = false;
            this.sharedService.favData.size = 0;
            let ids = [];
            this.sharedService.favData.sessions.forEach((element) => {
                ids.push(element.id);
            });
            this.messageService.sendMessage("add-all-fav-to-cart", ids);
            this.toggleTab("registered");
        });
    }

    removeAll(isExcluded) {
        this.attendeeSessionService
            .removeAllFromFavourite(this.sharedService.loggedInAttendee.uuid, isExcluded)
            .subscribe((response) => {
                if (isExcluded) {
                    this.sharedService.excData.size = 0;
                }
                let ids = [];
                this.sharedService.favData.sessions.forEach((element) => {
                    ids.push(element.id);
                });
                this.messageService.sendMessage("remove-all-fav", ids);
                this.messageService.sendMessage("toggle-cart");
            });
    }

    clearCart() {
        this.attendeeSessionService.clearCart(this.sharedService.loggedInAttendee.uuid).subscribe((response) => {
            let ids = [];
            this.sharedService.cartData.sessions.forEach((element) => {
                ids.push(element.id);
            });
            this.messageService.sendMessage("clear-cart", ids);
            this.messageService.sendMessage("toggle-cart");
        });
    }
    createStyleString(styleConfig) {
        return (
            "{'margin' : '" +
            styleConfig.regionConfig.margin +
            "'," +
            "'padding': '" +
            styleConfig.regionConfig.padding +
            "'," +
            "'background': '" +
            styleConfig.textConfig.background +
            "'," +
            "'border-radius': '" +
            styleConfig.regionConfig.corner +
            "'," +
            "'color': '" +
            styleConfig.textConfig.textColor +
            "','position': 'relative'}"
        );
    }

    showFlag(list) {
        var show = [];
        var showRecurrence = [];
        for (let i = 0; i < list.length; ++i) {
            list[i].event = this.sharedService.event;
            list[i].registrations = this.sharedService.loggedInAttendee;
            show.push(true);

            // Add recurrence display text related information
            showRecurrence.push(false);
            if(!this.sharedService.isEmptyString(list[i].sessionRecurrence)) {
                var recurrenceJSON = JSON.parse(list[i].sessionRecurrence);
                list[i].recurringSessionFrequency = recurrenceJSON.cronDisplayText;
            }
        }
        this.param["show"] = show;
    }

    renderView(tab) {
        setTimeout(() => {
            if (this.selectedTab === "favorites" && this.listViewContainer != undefined && this.render) {
                this.listViewContainer.clear();
                this.showFlag(this.sharedService.favData.sessions);
                this.output = this.createTemplate(this.sharedService.favData.sessions);
                this.createComponentFromRaw(this.output, this.listViewContainer, this.listComp, "fav", this.param);
            } else if (this.selectedTab === "registered" && this.listViewContainer != undefined && this.render) {
                this.listViewContainer.clear();
                this.showFlag(this.sharedService.cartData.sessions);
                this.output = this.createTemplate(this.sharedService.cartData.sessions);
                this.createComponentFromRaw(this.output, this.listViewContainer, this.listComp, "reg", this.param);
            } else if (this.selectedTab === "excluded" && this.listViewContainer != undefined) {
                this.listViewContainer.clear();
                this.showFlag(this.sharedService.excData.sessions);
                this.output = this.createTemplate(this.sharedService.excData.sessions);
                this.createComponentFromRaw(this.output, this.listViewContainer, this.listComp, "exc", this.param);
            }
        }, 0);
    }

    @ViewChild("regListViewContainer", { read: ViewContainerRef })
    regListViewContainer: ViewContainerRef;
    private regListComp: ComponentRef<any>;

    @ViewChild("listViewContainer", { read: ViewContainerRef })
    listViewContainer: ViewContainerRef;
    private listComp: ComponentRef<any>;

    // Here we create the component.
    private createComponentFromRaw(template: string, containerRef: any, componentRef: any, section: any, param: any) {
        
        template = template.replace(/{/g, '&#123;');
        template = template.replace(/}/g, '&#125;');
        
        template = template
            .replace(new RegExp('contenteditable="true"', "g"), "")
            .replace(new RegExp("contenteditable='true'", "g"), ""); //to remove editable
        @CustomComponent({ template, selector: 'scTmpCmp' })
        class tmpCmp {
            ngOnInit() {}

            show = Object.assign([], param["show"]);
            showRecurrence =  Object.assign([], param["showRecurrence"]);
            removeElement(index, id, selectedTab) {
                if (selectedTab === "registered") {
                    param["attendeeSessionService"]
                        .removeFromCart(id, param["sharedService"].loggedInAttendee.uuid)
                        .subscribe((response) => {
                            this.show[index] = false;
                            param["messageService"].sendMessage("single-remove-cart", id);
                            param["sharedService"].cartData.size--;
                        });
                } else if (selectedTab === "favorites" || selectedTab === "excluded") {
                    param["attendeeSessionService"]
                        .removeFromFavourite(param["sharedService"].loggedInAttendee.uuid, id)
                        .subscribe((response) => {
                            this.show[index] = false;
                            if (selectedTab === "favorites") {
                                param["messageService"].sendMessage("single-remove-fav", id);
                                param["sharedService"].favData.size--;
                            } else {
                                param["sharedService"].excData.size--;
                            }
                        });
                }
            }

            processFav(index, id) {
                param["attendeeSessionService"]
                    .processFav(param["sharedService"].loggedInAttendee.uuid, id)
                    .subscribe((response) => {
                        this.show[index] = false;
                        param["messageService"].sendMessage("move-fav-to-cart", id);
                        param["sharedService"].favData.size--;
                        param["sharedService"].cartData.size++;
                    });
            }
        }

        @Custompipe({
            name: "toDateObj"
        })
        class ToDateObj implements PipeTransform {
            transform(value: any): any {
                if (value) {
                    return value.toString().replace(new RegExp(" ", "g"), "T");
                } else {
                    return null;
                }
            }
        }

        @CustomNgModule({
            imports: [RouterModule, CommonModule, CclSharedModule],
            declarations: [tmpCmp, ToDateObj]
        })
        class tmpModule {}

        this.compiler.compileModuleAndAllComponentsAsync(tmpModule).then((factories) => {
            containerRef.clear();
            const f = factories.componentFactories.find(element => element.selector === 'scTmpCmp');
            componentRef = f.create(this.injector, [], null, this.moduleRef);
            componentRef.instance.name = "cart-list-component";
            containerRef.insert(componentRef.hostView);
            this.sharedService.showLoader = true;
            this.section = section;
        });
    }
}

function CustomComponent(annotation: any) {
    return function(target: Function) {
        const component = new Component(annotation);
        Component(component)(target);
    };
}

function CustomNgModule(annotation: any) {
    return function(target: Function) {
        const ngModule = new NgModule(annotation);
        NgModule(ngModule)(target);
    };
}

function Custompipe(annotation: any) {
    return function(target: Function) {
        const pipe = new Pipe(annotation);
        Pipe(pipe)(target);
    };
}
